<div class="layout__inner-card">
  <h4 i18n>Rapports de codes MIB</h4>
  @if (data.length > 0) {
    <p-table [rowHover]="true" [value]="data">
      <ng-template pTemplate="header">
        <tr class="table-section__thead">
          <th pSortableColumn="date" i18n
            >Date
            <p-sortIcon field="date"></p-sortIcon>
          </th>
          <th class="flex gap-1 align-items-center" i18n
            >Endroit de résidence
            <span [pTooltip]="tooltipContent" [autoHide]="false" class="pi pi-info-circle p-1"></span
          ></th>
          <th i18n>Codes</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-tableEntry>
        <tr>
          <td>{{ tableEntry.submissionDate }}</td>
          <td>{{ getResidencePlace(tableEntry) }}</td>
          <td>{{ tableEntry.codes.join(', ') }}</td>
        </tr>
      </ng-template>
    </p-table>
  } @else {
    <p i18n>Aucun code</p>
  }
</div>

<ng-template #tooltipContent>
  <div id="codedReportToolTip">
    <p i18n>A – Delaware, District de Columbia, Maryland, New Jersey, Virginie, et Virginie-Occidentale</p>
    <p i18n>C – Alaska, Californie, Hawaï, Oregon, et Washington</p>
    <p i18n
      >E – Alabama, Floride, Géorgie, Kentucky, Mississippi, Caroline du Nord, Caroline du Sud, et
      Tennessee</p
    >
    <p i18n
      >F – Partout ailleurs que le Canada et les 50 états des États-Unis. F inclut les dépendances et les
      territoires des États-Unis comme Porto Rico</p
    >
    <p i18n>G – Indiana, Michigan, Ohio, Wisconsin</p>
    <p i18n>K – Canada</p>
    <p i18n>L – Illinois</p>
    <p i18n>M – Arizona, Colorado, Idaho, Montana, Nevada, Nouveau-Mexique, Utah, et Wyoming</p>
    <p i18n>N – Connecticut, Maine, Massachusetts, New Hampshire, Rhode Island, et Vermont</p>
    <p i18n>P – Iowa, Kansas, Minnesota, Missouri, Nebraska, Dakota du Nord, et Dakota du Sud</p>
    <p i18n>Q – Pennsylvanie</p>
    <p i18n>W – Arkansas, Louisiane, Oklahoma, Texas</p>
    <p i18n>Y – New York</p>
  </div>
</ng-template>
